import React, { useEffect } from "react";
import * as Constants from "../logic/Constants";

// Externals
import cn from "classnames";

// DevExtreme components
import TreeList, { Column } from 'devextreme-react/tree-list';
import { Toolbar, Item } from 'devextreme-react/toolbar';

// Component styles
import classes from "./ItemListWidget.module.scss";

export function ItemListWidget(props) {
  const { ui, data, config, doAction } = props;

  let widgetId = ui.id;
  let structures = config ? config.ItemStructures : [];
  let buttons = config ? config.Buttons : [];

  let content = data && data.content ? JSON.parse(data.content) : null;
  let currentSelectedItemId = content ? content.SelectedItemId : "";
  let items = content ? content.Items : null;
  let disabled = content ? content.Disabled : false;
  let enabledButtons = content ? content.EnabledButtons : null;
  let currentStructureId = content ? content.CurrentStructureId : null;

  let toolbarHeight = Constants.DEFAULT_ROW_HEIGHT + "em";
  let treeHeight = "calc(100% - " + toolbarHeight + ")";

  useEffect(() => {
    console.log("ItemListWidget data of " + ui.id + ": ", data);
  }, [data]);

  const onSelectionChanged = async (args) => {
    let newSelectedItemId = args.currentSelectedRowKeys[0];
    if (newSelectedItemId === currentSelectedItemId) return;
    if (isBabySitter(newSelectedItemId)) {
      args.component.deselectRows(newSelectedItemId);
      args.component.selectRows(currentSelectedItemId);
      return;
    }
    await doAction(Constants.ITEMLIST_WIDGET_SELECTED_ACTION, newSelectedItemId);
  };

  const onContentReady = (args) => {
    //console.log("CONTENT READY", args);
    args.component.navigateToRow(currentSelectedItemId);
  };

  const onStructureChanged = async (args) => {
    await doAction(Constants.ITEMLIST_WIDGET_CHANGEITEMSTUCTURE_ACTION, args.item.ItemId);
  };

  const onToolbarButtonClick = async (actionId) => {
    await doAction(actionId);
  };

  const hasNoSubItems = (items) => {
    if (!items || items.length === 0) return false;
    return (!items.some(i => i.Items && i.Items.length > 0));
  };

  const isBabySitter = (itemId) => {
    return itemId && itemId.startsWith("B_");
  };

  const findIcon = (actionId) => {
    switch (actionId) {
      case Constants.ITEMLIST_WIDGET_CHANGEITEMSTUCTURE_ACTION:
        return "alignleft";
      case Constants.ITEMLIST_WIDGET_MOVEITEMUP_ACTION:
        return "chevronup";
      case Constants.ITEMLIST_WIDGET_MOVEITEMDOWN_ACTION:
        return "chevrondown";
      case Constants.ITEMLIST_WIDGET_NEWROOT_ACTION:
        return "verticalaligntop";
      case Constants.ITEMLIST_WIDGET_NEWCHILD_ACTION:
        return "verticalalignbottom";
      case Constants.ITEMLIST_WIDGET_NEWSIBLING_ACTION:
        return "verticalaligncenter";
      default:
        return null;
    }
  };

  const isControlEnabled = (actionId) => {
    if (disabled) return false;
    if (enabledButtons) {
      return enabledButtons.includes(actionId);
    }
    return false;
  };

  const renderActionButton = (control) => {
    let isSupported = findIcon(control.ActionId) !== null;
    return isSupported
      ? (
        <Item
          key={control.ActionId}
          widget="dxButton"
          location="before"
          locateInMenu="auto"
          showText="inMenu"
          disabled={!isControlEnabled(control.ActionId)}
          options={{
            icon: findIcon(control.ActionId),
            hint: control.Tooltip,
            text: control.DisplayText,
            stylingMode: "text",
            onClick: () => onToolbarButtonClick(control.ActionId)
          }}
        />
      )
      : null;
  };

  const renderStructuresDropdown = (control) => {
    return (
      <Item
        key={control.ActionId}
        widget="dxDropDownButton"
        location="after"
        locateInMenu="auto"
        disabled={!isControlEnabled(control.ActionId)}
        options={{
          icon: findIcon(control.ActionId),
          selectedItemKey: currentStructureId,
          items: structures,
          hint: control.Tooltip,
          displayExpr: "DisplayData",
          keyExpr: "ItemId",
          stylingMode: "text",
          useSelectMode: true,
          onSelectionChanged: e => onStructureChanged(e),
          dropDownOptions: { minWidth: "200px" }
        }}
      />
    )
  }

  return (
    <div style={{ height: "100%" }}>
      <Toolbar
        className={cn(classes.toolbar, "dx-theme-border-color")}
        id={widgetId}
        style={{ height: toolbarHeight }}
      >
        {buttons.map(control => {
          switch (control.ActionId) {
            case Constants.ITEMLIST_WIDGET_CHANGEITEMSTUCTURE_ACTION:
              return renderStructuresDropdown(control);
            default:
              return renderActionButton(control);
          }
        }
        )}
      </Toolbar>
      <TreeList
        className={cn(hasNoSubItems(items) ? classes.treeListFlatStructure : "")}
        id={widgetId}
        disabled={disabled}
        dataSource={items}
        keyExpr="ItemId"
        itemsExpr="Items"
        dataStructure="tree"
        scrolling={{ mode: "standard", scrollByThumb: true }}
        selection={{ mode: "single" }}
        showColumnHeaders={false}
        showColumnLines={false}
        showRowLines={false}
        hoverStateEnabled={true}
        defaultSelectedRowKeys={[currentSelectedItemId]}
        onSelectionChanged={(e) => onSelectionChanged(e)}
        onContentReady={(e) => onContentReady(e)}
        height={treeHeight}
      >
        <Column
          dataField="DisplayData"
        />
      </TreeList>
    </div>
  );
}
